/* eslint-disable @typescript-eslint/no-explicit-any */
import { isAxiosError } from 'axios'

import { serverEvent } from '../eventSender'
import { Metadata } from '../eventSender/types'
import { buildAxiosErrorContext } from '../helpers/buildAxiosErrorContext'
import { Logger } from './types'

export class ClientSideLogger implements Logger {
  private readonly isCollecting: boolean

  constructor(collectLogs: boolean) {
    this.isCollecting = collectLogs
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setMetadata<T extends object>(metadata: T) {
    serverEvent.updateUserMetadata(metadata as Metadata)
  }

  info(message: string, context?: any): void {
    if (!this.isCollecting) {
      console.info(message, { context })
    }
  }

  warn(message: string, context?: any, error?: Error): void {
    if (this.isCollecting) {
      serverEvent.sendEvent({
        label: message,
        metadata: { ...context, error: error ?? new Error(message) }
      })
    } else {
      console.warn(message, { context }, error)
    }
  }

  error(message: string, context?: any, error?: Error): void {
    const axiosErrorContext = isAxiosError(error)
      ? { requestContext: buildAxiosErrorContext(error) }
      : {}

    const contextToSend = { ...context, ...axiosErrorContext }

    if (this.isCollecting) {
      serverEvent.sendEvent({
        label: message,
        metadata: { ...contextToSend, error }
      })
    } else {
      console.error(message, { context: contextToSend }, error)
    }
  }
}
